'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getTrackerHstc = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.getInitialProperties = getInitialProperties;

var _usageTracker = require('usage-tracker');

var _I18n = require('I18n');

var _I18n2 = _interopRequireDefault(_I18n);

var _events = require('../../../events.yaml');

var _events2 = _interopRequireDefault(_events);

var _getUtk = require('../utils/getUtk');

var _getUtk2 = _interopRequireDefault(_getUtk);

var _q = require('q');

var _q2 = _interopRequireDefault(_q);

var _deviceUtils = require('../utils/deviceUtils');

var _frame = require('../utils/frame');

var _hubspot = require('hubspot.SafeStorage');

var _hubspot2 = _interopRequireDefault(_hubspot);

var _envInfo = require('../constants/envInfo');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DEBUG_KEY = 'DISABLE_USAGE_TRACKER_DEBUG';

var getTrackerHstc = exports.getTrackerHstc = function getTrackerHstc() {
  return new _q2.default.Promise(function (resolve) {
    var interval = setInterval(function () {
      if ((0, _getUtk2.default)()) {
        clearInterval(interval);
        resolve('x.' + (0, _getUtk2.default)());
      }
    }, 100);
  });
};

function getInitialProperties() {
  return {
    namespace: 'signup',
    email: null,
    hubId: null,
    lang: _I18n2.default.currentLocale(),
    hstc: getTrackerHstc,
    platform: (0, _deviceUtils.getDevicePlatform)(),
    signupVersion: 'v2',
    signupMode: (0, _frame.isFramed)() ? 'embedded' : 'standalone'
  };
}

var DEFAULT_TRACKER = (0, _usageTracker.createTracker)({
  events: _events2.default,
  properties: getInitialProperties(),
  debug: _envInfo.isQA && !_hubspot2.default.getItem(DEBUG_KEY),
  preserveTrackerProperties: true,
  lastKnownEventProperties: ['screen']
});

var CURRENT_TRACKER = DEFAULT_TRACKER;

var UsageTrackerContainer = {
  get: function get() {
    return CURRENT_TRACKER;
  },
  track: function track(eventName, properties) {
    CURRENT_TRACKER.track(eventName, properties);
  },
  trackBeforeUnload: function trackBeforeUnload(eventName, properties) {
    CURRENT_TRACKER.clone({ isBeforeUnload: true }).track(eventName, properties);
  },
  setProperties: function setProperties(properties) {
    if (typeof properties.hubId === 'undefined') {
      properties.hubId = null; //this will ensure the tracker is considered not authenticated avoiding any unexpected redirect
    }
    if (properties.hubId) {
      // Sanitize hubId to always be an integer
      return CURRENT_TRACKER.setProperties(_extends({}, properties, {
        hubId: parseInt(properties.hubId, 10)
      }));
    }
    return CURRENT_TRACKER.setProperties(properties);
  },
  set: function set(trackerInstance) {
    CURRENT_TRACKER = trackerInstance;
  }
};

exports.default = UsageTrackerContainer;